import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { saveAction } from '../services/settingsServices'
import { useNavigate } from 'react-router-dom'

export function useActionUpdate() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const {
    mutate: actionUpdate,
    isLoading: isLoadingActionUpdate,
    error,
    isSuccess,
  } = useMutation({
    mutationFn: saveAction,
  })

  useEffect(() => {
    if (isSuccess) {
      queryClient.removeQueries({ queryKey: ['actionsList'] })
      navigate("/actions")
    }
  }, [isSuccess, queryClient, navigate])

  return {
    actionUpdate,
    isLoadingActionUpdate,
    error,
    isSuccessActionUpdate: isSuccess,
  }
}
